export const auth = state => {
  return state.auth
}
